import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { SavedProvider } from "./saved";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <SavedProvider><App /></SavedProvider>
    </BrowserRouter>
  </React.StrictMode>
);
